Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Wistia", {
  enumerable: true,
  get: function get() {
    return _wistia.Wistia;
  }
});
var _wistia = require("./wistia");